import config from "@/config"
import http from "@/utils/request"
export default {
    schemeList:{
		url: `${config.WATER_MODEL_SCREEN_URL}/scheme/`,
		name: "获取方案列表",
		get: async function(deviceNumber){
			return await http.get(this.url+deviceNumber+'/');
		}
	},
    addScheme:{
		url: `${config.WATER_MODEL_SCREEN_URL}/scheme/add/`,
		name: "新增方案",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    deleteScheme:{
		url: `${config.WATER_MODEL_SCREEN_URL}/scheme/delete`,
		name: "删除方案",
		delete: async function(data){
			return await http.delete(this.url, data);
		}
	},
    customTemplateList:{
		url: `${config.WATER_MODEL_SCREEN_URL}template/list`,
		name: "获取自定义模板列表",
		get: async function(){
			return await http.get(this.url);
		}
	},
    batchSetTemplate:{
		url: `${config.WATER_MODEL_SCREEN_URL}scheme/batch-set-template`,
		name: "批量设置模板",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    saveCustomTemplate:{
		url: `${config.WATER_MODEL_SCREEN_URL}template/save`,
		name: "保存自定义模板",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    saveTemplate:{
		url: `${config.WATER_MODEL_SCREEN_URL}/waterFilmScreen/template`,
		name: "保存模板",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    templateList:{
		url: `${config.WATER_MODEL_SCREEN_URL}/waterFilmScreen/template`,
		name: "获取模板列表",
		get: async function(params){
			return await http.get(this.url, params);
		}
	},
    systemTemplateList:{
		url: `${config.WATER_MODEL_SCREEN_URL}/waterFilmScreen/system/template`,
		name: "获取系统模板列表",
		get: async function(params){
			return await http.get(this.url, params);
		}
	},
    deleteTemplate:{
		url: (templateId) => `${config.WATER_MODEL_SCREEN_URL}/waterFilmScreen/template/${templateId}`,
		name: "删除模板",
		delete: async function(templateId){
			return await http.delete(this.url(templateId));
		}
	},
    updateTemplateName:{
		url: (templateId) => `${config.WATER_MODEL_SCREEN_URL}/waterFilmScreen/template/${templateId}`,
		name: "修改模板名称",
		put: async function(templateId, data){
			return await http.put(this.url(templateId), data);
		}
	},
    batchAddScheme:{
		url: `${config.WATER_MODEL_SCREEN_URL}/scheme/batch/add/`,
		name: "批量添加方案",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
	deviceAttribute: {
        url: `${config.WATER_MODEL_SCREEN_URL}/device/attribute/`,
        name: "设备属性值（墨水屏）",
        get: async function (deviceNumber) {
            return await http.get(this.url + deviceNumber + '/');
        }
    },
	setHeartbeatInterval: {
		url: `${config.WATER_MODEL_SCREEN_URL}/device/attribute/heartbeatInterval`,
		name: "设置心跳间隔（墨水屏）",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	}
}